

// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchEmployees } from "../redux/actions/employeeActions";

// const Employee = () => {
//   const dispatch = useDispatch();
//   const { employees, loading, error } = useSelector((state) => state.employee);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [selectedMunicipality, setSelectedMunicipality] = useState("");
//   const [selectedWard, setSelectedWard] = useState("");

//   const itemsPerPage = 10;

//   const districts = [...new Set(employees.map((emp) => emp.district).filter(Boolean))];
//   const municipalities = [...new Set(employees.map((emp) => emp.municipality).filter(Boolean))];
//   const wards = [...new Set(employees.map((emp) => emp.ward).filter(Boolean))];

//   useEffect(() => {
//     dispatch(fetchEmployees());
//   }, [dispatch]);

//   const filteredEmployees = employees.filter((emp) =>
//     (emp?.name || "").toLowerCase().includes(searchTerm.toLowerCase()) &&
//     (selectedDistrict ? emp.district === selectedDistrict : true) &&
//     (selectedMunicipality ? emp.municipality === selectedMunicipality : true) &&
//     (selectedWard ? emp.ward === selectedWard : true)
//   );

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredEmployees.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);

//   const handleNext = () => {
//     if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
//   };

//   const handlePrevious = () => {
//     if (currentPage > 1) setCurrentPage((prev) => prev - 1);
//   };

//   return (
//     <div className="w-full h-auto bg-gray-100 p-4">
//       <h1 className="text-2xl font-bold text-gray-900 mb-4">Employee Management</h1>

//       {/* Filters Aligned to Left */}
//       <div className="flex flex-wrap gap-2 mb-6 items-center justify-start">
//         <select
//           value={selectedDistrict}
//           onChange={(e) => {
//             setSelectedDistrict(e.target.value);
//             setCurrentPage(1);
//           }}
//           className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
//         >
//           <option value="">All Districts</option>
//           {districts.map((district) => (
//             <option key={district} value={district}>
//               {district}
//             </option>
//           ))}
//         </select>

//         <select
//           value={selectedMunicipality}
//           onChange={(e) => {
//             setSelectedMunicipality(e.target.value);
//             setCurrentPage(1);
//           }}
//           className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
//         >
//           <option value="">All Municipalities</option>
//           {municipalities.map((mun) => (
//             <option key={mun} value={mun}>
//               {mun}
//             </option>
//           ))}
//         </select>

//         <select
//           value={selectedWard}
//           onChange={(e) => {
//             setSelectedWard(e.target.value);
//             setCurrentPage(1);
//           }}
//           className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
//         >
//           <option value="">All Wards</option>
//           {wards.map((ward) => (
//             <option key={ward} value={ward}>
//               {ward}
//             </option>
//           ))}
//         </select>

//         <input
//           type="text"
//           placeholder="Search by name, email, phone or Designation"
//           value={searchTerm}
//           onChange={(e) => {
//             setSearchTerm(e.target.value);
//             setCurrentPage(1);
//           }}
//           className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none w-[350px]"
//         />
//       </div>

//       {loading && <p>Loading employees...</p>}
//       {error && <p className="text-red-600">Error: {error}</p>}

//       {filteredEmployees.length > 0 ? (
//         <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
//           <table className="min-w-full text-sm">
//             <thead className="bg-black text-white">
//               <tr>
//                 <th className="px-4 py-3">ID</th>
//                 <th className="px-4 py-3">Photo</th>
//                 <th className="px-4 py-3">Name</th>
//                 <th className="px-4 py-3">Email</th>
//                 <th className="px-4 py-3">Phone</th>
//                 <th className="px-4 py-3">Designation</th>
//                 <th className="px-4 py-3">Latitude</th>
//                 <th className="px-4 py-3">Longitude</th>
//                 <th className="px-4 py-3">District</th>
//                 <th className="px-4 py-3">Municipality</th>
//                 <th className="px-4 py-3">Ward</th>
//                 <th className="px-4 py-3">DOB</th>
//                 <th className="px-4 py-3">DOJ</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {currentItems.map((emp) => (
//                 <tr key={emp.id} className="hover:bg-gray-50">
//                   <td className="px-4 py-2">{emp.id}</td>
//                   <td className="px-4 py-2">
//                     <img
//                      src={emp.photo || "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?semt=ais_hybrid&w=740"}
//                       alt="Profile"
//                       className="h-10 w-10 rounded-full object-cover"
//                     />
//                   </td>
//                   <td className="px-4 py-2">{emp.name}</td>
//                   <td className="px-4 py-2">{emp.email}</td>
//                   <td className="px-4 py-2">{emp.phone}</td>
//                   <td className="px-4 py-2 capitalize">{emp.designation}</td>
//                   <td className="px-4 py-2">{emp.latitude}</td>
//                   <td className="px-4 py-2">{emp.longitude}</td>
//                   <td className="px-4 py-2">{emp.district || "-"}</td>
//                   <td className="px-4 py-2">{emp.municipality}</td>
//                   <td className="px-4 py-2">{emp.ward}</td>
//                   <td className="px-4 py-2">
//                     {emp.dob ? new Date(emp.dob).toLocaleDateString("en-IN") : "-"}
//                   </td>
//                   <td className="px-4 py-2">
//                     {emp.doj ? new Date(emp.doj).toLocaleDateString("en-IN") : "-"}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           <div className="flex justify-between items-center p-4 border-t">
//             <button
//               onClick={handlePrevious}
//               disabled={currentPage === 1}
//               className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
//             >
//               Previous
//             </button>
//             <p className="text-sm">
//               Page {currentPage} of {totalPages}
//             </p>
//             <button
//               onClick={handleNext}
//               disabled={currentPage === totalPages}
//               className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       ) : (
//         !loading && <p>No Employees available.</p>
//       )}
//     </div>
//   );
// };

// export default Employee;


import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchEmployees } from "../redux/actions/employeeActions";

const Employee = () => {
  const dispatch = useDispatch();
  const { employees, loading, error } = useSelector((state) => state.employee);

  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedMunicipality, setSelectedMunicipality] = useState("");
  const [selectedWard, setSelectedWard] = useState("");

  const itemsPerPage = 10;

  const districts = [...new Set(employees.map((emp) => emp.district).filter(Boolean))];
  const municipalities = [...new Set(employees.map((emp) => emp.municipality).filter(Boolean))];
  const wards = [...new Set(employees.map((emp) => emp.ward).filter(Boolean))];

  useEffect(() => {
    dispatch(fetchEmployees());
  }, [dispatch]);

  const filteredEmployees = employees.filter((emp) => {
    const searchLower = searchTerm.toLowerCase();
    const matchesSearch =
      (emp?.name || "").toLowerCase().includes(searchLower) ||
      (emp?.email || "").toLowerCase().includes(searchLower) ||
      (emp?.phone || "").toLowerCase().includes(searchLower) ||
      (emp?.designation || "").toLowerCase().includes(searchLower);

    const matchesDistrict = selectedDistrict ? emp.district === selectedDistrict : true;
    const matchesMunicipality = selectedMunicipality ? emp.municipality === selectedMunicipality : true;
    const matchesWard = selectedWard ? emp.ward === selectedWard : true;

    return matchesSearch && matchesDistrict && matchesMunicipality && matchesWard;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredEmployees.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  return (
    <div className="w-full h-auto bg-gray-100 p-4">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Employee Management</h1>

      {/* Filters Aligned to Left */}
      <div className="flex flex-wrap gap-2 mb-6 items-center justify-start">
        <select
          value={selectedDistrict}
          onChange={(e) => {
            setSelectedDistrict(e.target.value);
            setCurrentPage(1);
          }}
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
        >
          <option value="">All Districts</option>
          {districts.map((district) => (
            <option key={district} value={district}>
              {district}
            </option>
          ))}
        </select>

        <select
          value={selectedMunicipality}
          onChange={(e) => {
            setSelectedMunicipality(e.target.value);
            setCurrentPage(1);
          }}
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
        >
          <option value="">All Municipalities</option>
          {municipalities.map((mun) => (
            <option key={mun} value={mun}>
              {mun}
            </option>
          ))}
        </select>

        <select
          value={selectedWard}
          onChange={(e) => {
            setSelectedWard(e.target.value);
            setCurrentPage(1);
          }}
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
        >
          <option value="">All Wards</option>
          {wards.map((ward) => (
            <option key={ward} value={ward}>
              {ward}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Search by name, email, phone or designation"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none w-[350px]"
        />
      </div>

      {loading && <p>Loading employees...</p>}
      {error && <p className="text-red-600">Error: {error}</p>}

      {filteredEmployees.length > 0 ? (
        <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
          <table className="min-w-full text-sm">
            <thead className="bg-black text-white">
              <tr>
                <th className="px-4 py-3">ID</th>
                <th className="px-4 py-3">Photo</th>
                <th className="px-4 py-3">Name</th>
                <th className="px-4 py-3">Email</th>
                <th className="px-4 py-3">Phone</th>
                <th className="px-4 py-3">Designation</th>
                <th className="px-4 py-3">Latitude</th>
                <th className="px-4 py-3">Longitude</th>
                <th className="px-4 py-3">District</th>
                <th className="px-4 py-3">Municipality</th>
                <th className="px-4 py-3">Ward</th>
                <th className="px-4 py-3">DOB</th>
                <th className="px-4 py-3">DOJ</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {currentItems.map((emp) => (
                <tr key={emp.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2">{emp.id}</td>
                  <td className="px-4 py-2">
                    <img
                      src={
                        emp.photo ||
                        "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?semt=ais_hybrid&w=740"
                      }
                      alt="Profile"
                      className="h-10 w-10 rounded-full object-cover"
                    />
                  </td>
                  <td className="px-4 py-2">{emp.name}</td>
                  <td className="px-4 py-2">{emp.email}</td>
                  <td className="px-4 py-2">{emp.phone}</td>
                  <td className="px-4 py-2 capitalize">{emp.designation}</td>
                  <td className="px-4 py-2">{emp.latitude}</td>
                  <td className="px-4 py-2">{emp.longitude}</td>
                  <td className="px-4 py-2">{emp.district || "-"}</td>
                  <td className="px-4 py-2">{emp.municipality}</td>
                  <td className="px-4 py-2">{emp.ward}</td>
                  <td className="px-4 py-2">
                    {emp.dob ? new Date(emp.dob).toLocaleDateString("en-IN") : "-"}
                  </td>
                  <td className="px-4 py-2">
                    {emp.doj ? new Date(emp.doj).toLocaleDateString("en-IN") : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex justify-between items-center p-4 border-t">
            <button
              onClick={handlePrevious}
              disabled={currentPage === 1}
              className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
            >
              Previous
            </button>
            <p className="text-sm">
              Page {currentPage} of {totalPages}
            </p>
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      ) : (
        !loading && <p>No Employees available.</p>
      )}
    </div>
  );
};

export default Employee;
